// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggleNav[data-v-3d9e4ea4]{position:absolute;right:-15px;top:30px;z-index:20}#app[data-v-3d9e4ea4]{background-color:#f5f5f5}@media print{#app[data-v-3d9e4ea4]{background-color:transparent}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
